/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  AHdeviceTypeEnum,
  SendInvUpgradeByAHInput,
  SendInvUpgradeByAHResponse,
} from '..';
import {
  serializeSendInvUpgradeByAHInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface SendInvUpgradeByAHForWebInput {
  loggerId: string;
  deviceSN: string;
  deviceType: AHdeviceTypeEnum;
  transactionId: string;
  input: SendInvUpgradeByAHInput[];
}
const build = (_query: DocumentNode, input: SendInvUpgradeByAHForWebInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.loggerId !== undefined ? `$loggerId: String = ${JSON.stringify(input.loggerId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.deviceSN !== undefined ? `$deviceSN: String = ${JSON.stringify(input.deviceSN).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.deviceType !== undefined ? `$deviceType: AHdeviceTypeEnum = ${input.deviceType}, ` : '' ) + ``+
    ( input.transactionId !== undefined ? `$transactionId: String = ${JSON.stringify(input.transactionId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.input !== undefined ? `$input:  [ SendInvUpgradeByAHInput ]  = ${'[' + input.input.map((item) => serializeSendInvUpgradeByAHInput(item)).join(",") + ']'}` : '' ) + `){
    sendInvUpgradeByAHForWeb(
      ${ input.loggerId !== undefined ? 'loggerId: $loggerId,' : '' } 
      ${ input.deviceSN !== undefined ? 'deviceSN: $deviceSN,' : '' } 
      ${ input.deviceType !== undefined ? 'deviceType: $deviceType,' : '' } 
      ${ input.transactionId !== undefined ? 'transactionId: $transactionId,' : '' } 
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...sendinvupgradebyahresponse
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class SendInvUpgradeByAHForWebMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment sendinvupgradebyahresponse on SendInvUpgradeByAHResponse { ... }
   */
  async execute(_query: DocumentNode, input: SendInvUpgradeByAHForWebInput): Promise<apollo.FetchResult< { sendInvUpgradeByAHForWeb: Partial<SendInvUpgradeByAHResponse> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ sendInvUpgradeByAHForWeb: Partial<SendInvUpgradeByAHResponse> }>({ mutation: build(_query, input) });
  }
}
